<template></template>

<script type="text/ecmascript-6">
  export default {
    name: 'language',
    created () {
      // 匹配当前系统语言
      switch (window.navigator.language) {
        case 'zh-TW':
          // 繁体
          window.location.href = 'https://goo.gl/kaR9sk'
          break
        case 'zh-CN':
          // 简体
          window.location.href = 'http://developer.zm.yingxiong.com/#/rootDoc'
          break
        default:
          // 英文
          window.location.href = 'https://reurl.cc/q5lME'
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/language/language.vue